/* eslint-disable */
export enum FeatureFlagsEnum {
    DistributionCoverArtGenerator = 'D_CoverArtGenerator',
    MasteringStandardPlugin = 'P_MasteringStandardPlugin',
    StudioProFreeTrial = 'B_StudioProFreeTrial',
    StudioEssentials = 'B_StudioEssentials',
}
